import React, { useEffect, useState, useRef } from 'react'
import {
    rentService as service,
    carService,
    billService,
    suscriptoorService,
} from '../../services'
import { Grid } from '@mui/material'
import { panelSuscription } from '../utils/Utils'

export default function PanelSus() {
    const [{ suscriptors }, setState] = React.useState<any>({
        suscriptors: [],
    })

    useEffect(() => {
        searchData()
    }, [])

    const searchData = () => {
        suscriptoorService.all((data, error) => {
            if (data && data.data) {
                var aux: any[] = []
                data.data.forEach((element) => {
                    if (element.lat && element.lng) {
                        aux.push(element)
                    }
                })
                setState((currentState) => ({
                    ...currentState,
                    ['suscriptors']: dedupByCar(data.data),
                }))
            }
        })
    }

    // Una compañía puede tener varias Suscription activas (endReal IS NULL) para
    // el mismo coche por renovaciones de contrato sin cerrar la anterior. El
    // backend las devuelve TODAS porque el filtro NotFinish solo descarta las
    // que ya tienen endReal. Aquí nos quedamos con la más reciente por car.id
    // (id mayor = contrato creado más tarde) para evitar duplicados visuales.
    const dedupByCar = (list: any[]): any[] => {
        const map = new Map<any, any>()
        for (const sus of list || []) {
            const carId = sus?.car?.id
            if (carId == null) continue
            const prev = map.get(carId)
            if (!prev || (sus.id ?? 0) > (prev.id ?? 0)) {
                map.set(carId, sus)
            }
        }
        return Array.from(map.values())
    }

    return (
        <Grid container>
            {suscriptors != null &&
                suscriptors.length > 0 &&
                suscriptors.map((sus) => (
                    <Grid key={sus.id} xs={12} sm={3} md={2}>
                        {panelSuscription(sus)}
                    </Grid>
                ))}
        </Grid>
    )
}
